const phoneConvert = (phone) => {
    const cleanedPhoneNumber = phone.replace(/[-\s]/g, '');
    const internationalPhoneNumber = `+62${cleanedPhoneNumber.slice(1)}`;
    return internationalPhoneNumber
}

export default phoneConvert